import { PLANS } from '@/entities/plan';
import type { UserProfile } from '@/entities/user-profile';


/** Участник команды (любая роль) видит план команды, пользователь вне команды — личный план. */
export function getPlanLabel (profile: Pick<UserProfile, 'plan_id' | 'team'>): string | undefined {
    const membership = profile.team?.membership;

    if (membership) return `Team Plan × ${ membership.plan_name }`;

    return PLANS.find(plan => plan.id === profile.plan_id)?.name;
}
